var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AvatarBlock } from '../avatar-block';
import { ColumnLayout } from '../column-layout';
import { useId } from '../utils/use-id';
import { styled } from '../styled';
import clsx from '../utils/clsx';
import { composeClasses } from '../styles/classes';
import { configBlockComponentName, getConfigBlockUtilityClass } from './config-block-classes';
var isControlRenderer = function (node) {
    return typeof node === 'function';
};
var Control = styled('div', {
    name: configBlockComponentName,
    slot: 'Control',
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
        },
        _b[theme.breakpoints.up('sm')] = {
            justifyContent: 'flex-end',
        },
        _b);
});
var useUtilityClasses = function (_a) {
    var classes = _a.classes;
    var slots = {
        root: ['root'],
        avatar: ['avatar'],
        control: ['control'],
    };
    return composeClasses(slots, getConfigBlockUtilityClass, classes);
};
export var ConfigBlock = React.forwardRef(function (props, ref) {
    var classes = useUtilityClasses(props);
    var propId = props.id, avatar = props.avatar, title = props.title, description = props.description, className = props.className, _a = props.titleTypographyProps, titleTypographyProps = _a === void 0 ? {} : _a, _b = props.descriptionTypographyProps, descriptionTypographyProps = _b === void 0 ? {} : _b, _c = props.AvatarBlockProps, AvatarBlockProps = _c === void 0 ? {} : _c, control = props.control, propClasses = props.classes, rootProps = __rest(props, ["id", "avatar", "title", "description", "className", "titleTypographyProps", "descriptionTypographyProps", "AvatarBlockProps", "control", "classes"]);
    var id = useId(propId);
    var controlId = id && "".concat(id, "-control");
    var helperTextId = id && "".concat(id, "-description");
    return (React.createElement(ColumnLayout, __assign({ distribution: "3/4 1/4", gutter: [2, 2, 4], sx: { alignItems: 'center' }, className: clsx(classes.root, className) }, rootProps, { ref: ref }),
        React.createElement(AvatarBlock, __assign({ className: classes.avatar, avatar: avatar, title: title, description: description, titleTypographyProps: __assign({ component: 'label', htmlFor: controlId, variant: 'subtitle1' }, titleTypographyProps), descriptionTypographyProps: __assign({ id: helperTextId }, descriptionTypographyProps) }, AvatarBlockProps, { TitleBlockProps: __assign({ gutter: 0.5 }, AvatarBlockProps.TitleBlockProps) })),
        control && (React.createElement(Control, { className: classes.control }, isControlRenderer(control)
            ? control({ id: id, controlId: controlId, helperTextId: helperTextId })
            : React.Children.map(control, function (child) {
                if (!child) {
                    return null;
                }
                if (!React.isValidElement(child)) {
                    return child;
                }
                return React.cloneElement(child, {
                    id: controlId,
                    'aria-describedby': helperTextId,
                });
            })))));
});
